import { render, staticRenderFns } from "./CustomLabelsConfig.vue?vue&type=template&id=46b37209"
import script from "./CustomLabelsConfig.vue?vue&type=script&lang=js"
export * from "./CustomLabelsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46b37209')) {
      api.createRecord('46b37209', component.options)
    } else {
      api.reload('46b37209', component.options)
    }
    module.hot.accept("./CustomLabelsConfig.vue?vue&type=template&id=46b37209", function () {
      api.rerender('46b37209', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/CustomLabelsConfig.vue"
export default component.exports